import React, { useState } from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";

export default function AutocompleteTextArea({
  setValues,
  values = [],
  maxInputs,
  label,
  placeholder,
}) {
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && values.length < maxInputs) {
      event.preventDefault();
      if (inputValue.trim() !== "") {
        setValues([...values, inputValue.trim()]);
        setInputValue(""); // Clear input field after adding
      }
    } else if (
      event.key === "Backspace" &&
      values.length > 0 &&
      inputValue === ""
    ) {
      setValues(values.slice(0, values.length - 1));
    }
  };

  const handleDelete = (valueToDelete) => () => {
    setValues(values.filter((value) => value !== valueToDelete));
  };

  return (
    <Autocomplete
      style={{ margin: "6px 0px" }}
      multiple
      freeSolo
      options={[]} // Disable dropdown options
      value={values}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant="outlined"
            label={option}
            {...getTagProps({ index })}
            onDelete={handleDelete(option)}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
        />
      )}
    />
  );
}
